export const SPECS = {
  AddIsPickupFlowToCheckoutUrl: 'specs.stores.AddIsPickupFlowToCheckoutUrl',
  ShouldSupportTimeSlotsInCheckout: 'specs.stores.ShouldSupportTimeSlotsInCheckout',
  Fix3DSInExpressMethods: 'specs.stores.Fix3DSInExpressMethods'
};
//# sourceMappingURL=SPECS.js.map